import baseAPI from "@/http";

const router = "api/projeto/solucao";
const routerMunicipioGrupo = "api/municipio/municipioGrupoSolucao";
const routerMunicipioSolucao = "api/municipio/municipioSolucao";

export const solutionAPI = {
  create: (solution) => baseAPI.post(router, solution),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(`${router}/listAll`),
  getSolutions: (ids) => baseAPI.post(router + "/get-by-eixos", ids),
  getByGrupo: (groupSolutionId, municipioId) =>
    baseAPI.post(
      router + "/get-by-grupo/" + groupSolutionId + "/" + municipioId
    ),
  get: (id) => baseAPI.get(`${router}/${id}`),
  reabilitarSolucao: (municipioId, municipiogruposolucaoid) =>
    baseAPI.put(
      `${routerMunicipioSolucao}/reabilitar-solucao/${municipioId}/${municipiogruposolucaoid}`
    ),
};
